const STORAGE_KEYS = {
    USER_TOKEN: 'userToken',
    USER_DATA: 'userData',
    AUTH_DATA: 'authData',
    IS_LOGGED_IN: 'isLoggedIn'
};

export const storeAuthData = (responseData) => {
    try {
        const user = {
            name: responseData.data.name,
            email: responseData.data.email,
            phone: responseData.data.phone,
            age: responseData.data.age,
            gender: responseData.data.gender,
            status: responseData.data.status,
            role: responseData.data.role,
            profile_img: responseData.data.profile_img,
            profile_complete_status: responseData.data.profile_complete_status,
        };

        const authData = {
            token: responseData.token,
            user,
            isLoggedIn: true
        };

        localStorage.setItem(STORAGE_KEYS.USER_TOKEN, responseData.token);
        localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(user));
        localStorage.setItem(STORAGE_KEYS.AUTH_DATA, JSON.stringify(authData));
        localStorage.setItem(STORAGE_KEYS.IS_LOGGED_IN, "true");

        return true;
    } catch (error) {
        console.error("Error storing auth data:", error);
        return false;
    }
};

export const getToken = () => {
    return localStorage.getItem(STORAGE_KEYS.USER_TOKEN);
};

export const getUserData = () => {
    const data = localStorage.getItem(STORAGE_KEYS.USER_DATA);
    return data ? JSON.parse(data) : null;
};

export const getAuthData = () => {
    const data = localStorage.getItem(STORAGE_KEYS.AUTH_DATA);
    return data ? JSON.parse(data) : null;
};

export const isLoggedIn = () => {
    return localStorage.getItem(STORAGE_KEYS.IS_LOGGED_IN) === "true";
};

export const clearAuthData = () => {
    localStorage.removeItem(STORAGE_KEYS.USER_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER_DATA);
    localStorage.removeItem(STORAGE_KEYS.AUTH_DATA);
    localStorage.removeItem(STORAGE_KEYS.IS_LOGGED_IN);
};

export const updateUserField = (field, value) => {
    const user = getUserData();
    if (user) {
        user[field] = value;
        localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(user));

        const auth = getAuthData();
        if (auth) {
            auth.user[field] = value;
            localStorage.setItem(STORAGE_KEYS.AUTH_DATA, JSON.stringify(auth));
        }
    }
};